import { Component, Input } from '@angular/core';
import { Tag } from 'primeng/tag';
import { TherapyPlanStatusTranslationsPipe } from '@therapist/shared/pipes/therapy-plan-status-translations/therapy-plan-status-translations.pipe';
import { TherapyPlanStatusEnum } from '@therapist/shared/models/therapy-plan/therapy-plan-status.enum';

@Component({
  selector: 'sana-tp-therapy-plan-status-tag',
  imports: [
    Tag,
    TherapyPlanStatusTranslationsPipe
  ],
  templateUrl: './therapy-plan-status-tag.component.html',
  styleUrl: './therapy-plan-status-tag.component.scss'
})
export class TherapyPlanStatusTagComponent {

  @Input({ required: true }) status!: TherapyPlanStatusEnum;

  getSeverity(status: TherapyPlanStatusEnum): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' {
    if (status === TherapyPlanStatusEnum.Started) {
      return 'success';
    } else if (status === TherapyPlanStatusEnum.Planned) {
      return 'info';
    } else if (status === TherapyPlanStatusEnum.Canceled) {
      return 'danger';
    }

    return 'contrast';
  }
}
